export const updateBlogPagination = (currentPage: Element, pagination: Element): void => {

  const FIRST_PAGE = 'first-pageNumber';
  const SECOND_PAGE = 'second-pageNumber';
  const LAST_PAGE = 'last-pageNumber';
  const SECOND_LAST_PAGE = 'second-last-pageNumber';
  const IS_ACTIVE = 'blogpagination-item--active';
  const IS_AROUND = 'is-around';
  const SHOW_DOTS = 'show-dots';
  const IS_NEXT_TO = 'is-next-to';

  const pageLinks = pagination.querySelectorAll('.blogpagination-item:not(.blogpagination-item--previous):not(blogpagination-item--next)');
  const lastPage = pageLinks.length - 1;
  const newIndex = parseInt((currentPage as HTMLElement).dataset.page) - 1;

  pageLinks.forEach((paginationItem: HTMLElement) => {

    paginationItem.classList.remove(IS_ACTIVE, IS_AROUND, SHOW_DOTS, IS_NEXT_TO);
    const paginationLink = paginationItem.firstElementChild as HTMLElement;
    const pageNumber = parseInt(paginationLink.dataset.page) - 1;

    // if (pageNumber === 0) paginationItem.classList.add(FIRST_PAGE);
    // if (pageNumber === 1) paginationItem.classList.add(SECOND_PAGE);
    // if (pageNumber === lastPage) paginationItem.classList.add(LAST_PAGE);
    // if (pageNumber === lastPage - 1) paginationItem.classList.add(SECOND_LAST_PAGE);

    if (pageNumber === newIndex) {
      paginationItem.classList.add(IS_ACTIVE);
      return;
    }

    if (pageNumber === 0 || pageNumber === lastPage) {
      return;
    }

    if (Math.abs(pageNumber - newIndex) === 1) {
      paginationItem.classList.add(IS_NEXT_TO);
    }

    if (
      newIndex >= 4 && pageNumber === 1 ||
      (newIndex < lastPage - 2 && pageNumber === lastPage - 2)
    ) {
      paginationItem.classList.add(SHOW_DOTS);
    }

    if (
      Math.abs(pageNumber - newIndex) === 1 ||
      (newIndex < 4 && pageNumber <= 4) ||
      (newIndex >= lastPage - 3 && pageNumber >= lastPage - 4)
    ) {
      paginationItem.classList.add(IS_AROUND);
    }

  })

}
